export enum PlacementTypes {
    top = 'top' as any,
    bottom = 'bottom' as any,
    left = 'left' as any,
    right = 'right' as any,
    topLeft = 'top-left' as any,
    topRight = 'top-right' as any,
    bottomLeft = 'bottom-left' as any,
    bottomRight = 'bottom-right' as any
}
